// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2agBy","title":"ClientInsurance_title__1L-Sl","itemText":"ClientInsurance_itemText__2-8e7"};